import keyMirror from 'keymirror';

export default keyMirror({
  CONTACT_US: null,
  MESSAGING_EMAIL: null,
  MESSAGING_CONVERSATIONS: null,
  JOB_POSTING: null
});
